module.exports = __webpack_public_path__ + "static/media/HomeTab1.8e3ccdda.jpg";